<div class="shell" [class.shell--menu-open]="menuOpen()">
  <aside class="sidebar" [attr.aria-hidden]="false">
    <div class="sidebar__brand">Eventy Admin Platform</div>
    <nav class="sidebar__nav" aria-label="Главное меню админки">
      @for (item of navItems; track item.path) {
        <a
          class="sidebar__link"
          [routerLink]="item.path"
          routerLinkActive="sidebar__link--active"
          (click)="closeMenu()"
        >
          <mat-icon class="sidebar__icon" aria-hidden="true">{{ item.icon }}</mat-icon>
          <span class="sidebar__label">{{ item.label }}</span>
        </a>
      }
    </nav>
  </aside>

  <header class="topbar">
    <button
      type="button"
      class="topbar__burger"
      [attr.aria-label]="menuOpen() ? 'Закрыть меню' : 'Открыть меню'"
      [attr.aria-expanded]="menuOpen()"
      (click)="toggleMenu()"
    >
      <mat-icon aria-hidden="true">{{ menuOpen() ? 'close' : 'menu' }}</mat-icon>
    </button>
    <div class="topbar__spacer"></div>
    <div class="topbar__user">
      @if (currentUser(); as u) {
        <span class="topbar__name">{{ u.name || u.email }}</span>
      }
      <button type="button" class="topbar__logout" (click)="logout()">
        Выйти
      </button>
    </div>
  </header>

  <main class="main">
    <router-outlet></router-outlet>
  </main>

  <button
    type="button"
    class="shell__backdrop"
    aria-label="Закрыть меню"
    (click)="closeMenu()"
  ></button>
</div>
